<template>
  <StatusChangeProcedureApplyInput label="转班"
                                   class="status-change-procedure-apply-roll-class"
                                   v-on="$listeners"
                                   :resolve-form="getApplyInfo">
    <template>
      <slot></slot>
    </template>
    <template #form>
      <el-form size="mini"
               label-width="120px"
               label-suffix="：">
        <el-form-item label="转入班级">
          <ClazzPicker v-model="form.targetClassId"
                       :error-resolver="clazzResolver"></ClazzPicker>
        </el-form-item>
        <el-form-item v-if="form.targetClassId">
          <StudentCourseDockPanel ref="dock"
                                  :student-id="studentId"
                                  :clazz-id="form.targetClassId"></StudentCourseDockPanel>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input v-model="form.remark"
                    type="textarea"
                    maxlength="200"></el-input>
        </el-form-item>
      </el-form>
    </template>
  </StatusChangeProcedureApplyInput>
</template>

<script>
import StatusChangeProcedureApplyInput from '../input'
import ClazzPicker from '../../../../../../../../biz/picker/clazz'
import StudentCourseDockPanel from '../../../../../wrapper/panel/student/course/dock'
export default {
  name: 'StatusChangeProcedureApplyRollClass',
  components: {
    StatusChangeProcedureApplyInput,
    ClazzPicker,
    StudentCourseDockPanel
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    studentInfo: {
      type: Object,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      form: {
        targetClassId: '',
        remark: ''
      }
    }
  },
  methods: {
    clazzResolver (clazz) {
      if (this.studentInfo.className === clazz.name) {
        return new Error('选择班级不能与原班级相同')
      }
    },
    getApplyInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.targetClassId) {
          reject(new Error('请选择转入班级'))
          return
        }
        if (!this.form.remark) {
          this.$confirm('未填写备注信息，确认继续吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleApply(this.form, resolve, reject)
          }).catch(() => {})
        } else {
          this.handleApply(this.form, resolve, reject)
        }
      })
    },
    handleApply (form, resolve, reject) {
      this.$nextTick(() => {
        const dock = this.$refs.dock
        const promise = dock ? dock.getDockInfo() : Promise.resolve()
        promise.then(result => {
          resolve({
            url: '/workspace/manager/status/change/procedure/rollClass/submitApply',
            data: this.$qs.stringify(this.$extend({
              postId: this.studentId
            }, form, this.extraParams, result))
          })
        }).catch(err => reject(err))
      })
    }
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          if (typeof this.form[key] === 'string') {
            this.form[key] = val[key] || ''
          } else {
            this.form[key] = val[key]
          }
        })
      }
    }
  }
}
</script>
